import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from './icons';
import Loaderelement from './loaderelement';


import '../styles/fallback_page.scss';

class FallbackPage extends React.Component{

	render(){
		return (<div className="intro-chapter fallback">
				<div className="inner-menu-holder">
					<main className="main-intro-screen">
						<div className="logo-icon">
							<Iconset.logo />
						</div>
						<div className="main-center-screen">
							<header>
								<div className="load-status">
									<Loaderelement
									isLoading={false}/>
									<h1>A Blossomentary</h1>
									<p>Sorry, your Browser does not support the interactive documentary.</p>
									<p>Please update your Browser.</p>
								</div>
							</header>
						</div>
					</main>
				</div>
			</div>);
	}
}

export default FallbackPage;


// WEBPACK FOOTER //
// ./src/scripts/fallbackPage.js